<div>
    <label>{{ label }}</label>
    <div class="bciti-select bciti-select-input" (click)="toggleDropdown()" #dropreference>
      <ul>
        <li>
          <span *ngIf="selected">{{ selected.name }}</span>
          <span class="placeholder" *ngIf="!selected">{{ placeholder }}</span>
          <span class="icon icon-caret-down"></span>
        </li>
      </ul>
      <app-external-systems-select-dropdown [reference]="dropreference" #dropdown>
        <div class="bciti-select bciti-select-dropdown no-margin">
          <ul>
            <ng-container *ngFor="let option of options">
              <li (click)="select(option)" *ngIf="option !== selected && option.lookup">
                {{ option.name }}
              </li>
            </ng-container>
          </ul>
        </div>
      </app-external-systems-select-dropdown>
    </div>
  </div>